import React from 'react';

export default function YajurUpakarmaPage() {
  return (
    

<div className="page-content container mx-auto p-4">
<h1>யஜூர் உபாகர்மா</h1>
<div>
  <div className="tab-section my-8">
<h2 className="text-2xl font-bold mb-4">தமிழ்</h2>
<div className="svk">ஆசமனம்</div>
<div className="hint">ஆசமனம், ப்ராணாயாமம் அடிக்கடி
  செய்யவேண்டியிருக்கும், எனவே, இதை நன்றாகத்
  தெரிந்து வைத்துக்கொண்டு கர்மாவைச் செய்தால்
  விரைவாகவும், சிறப்பாகவும் செய்யலாம்.
  </div>
<hr />
<div>
  <img src="assets/img/achamanam.gif" />
</div>
<div className="svk2">Achamanam - Audio </div>
    <audio controls>
    <source src="https://www.brahminsnet.com/audio/achamanam.ogg" type="audio/ogg" />
    <source src="https://www.brahminsnet.com/audio/achamanam.mp4" type="audio/mp4" />
  Your browser does not support the audio element.
  </audio>
<div className="hint">ஒரு நாளில், ஒரு கர்மாவின்
  ஆரம்பத்திலும், முடிவிலும் இரண்டு முறை
  ஆசமனம் செய்யவேண்டும். இடையிடையே
  ஒவ்வொரு முறை செய்தால் போறும்.
  </div>
  <hr />
<div className="sans">
  ओं अच्युताय नम:। ओं अनन्ताय नम:। <br />
  ओं गोविन्दााय नम:।<br />
  <div className="grid">
    <div className="flex flex-row flex-wrap">
      <div className="sans">ओं केशवाय नम:। </div>
      <div className="sans">नारायणाय नम:।</div>
    </div>
    <div className="flex flex-row flex-wrap">
      <div className="sans">माधवाय नम:।</div>
      <div className="sans">गोविन्दाय नम:।</div>
    </div>
    <div className="flex flex-row flex-wrap">
      <div className="sans">विष्णवे नम:। </div>
      <div className="sans">मधुसूदनाय नम:।
       </div>
    </div>
    <div className="flex flex-row flex-wrap">
      <div className="sans"> त्रिविक्रमाय नम:। </div>
      <div className="sans">वामनाय नम:।
        </div>
    </div>
    <div className="flex flex-row flex-wrap">
      <div className="sans">श्रीधराय नम:। </div>
      <div className="sans">हृषीकेशाय नम:।
        </div>
    </div>
    <div className="flex flex-row flex-wrap">
      <div className="sans">पद्मनाभाय नम:। </div>
      <div className="sans">दामोदराय नम:।</div>
    </div>
  </div>
   </div>
<hr />
<div>
    <img src="assets/img/Praanaayaamam1.jpg" className="img2" />

    <div className="hint">மணையில் இரு தர்பங்களை ஆசனமாகப்
      போட்டுக்கொண்டு, அதன்மேல் கிழக்கு நோக்கி அமரவும்.
      </div>
  </div>
  <hr />
  <div>
    <img src="assets/img/Praanaayaamam2.jpg" className="img2" />

    <div className="hint">இரு தர்பங்களாலான பவித்திரத்தை,
      வலது மோதிர விரலில் அணிந்து, அதனுடன் இரு
      தர்பங்களைச் சேர்த்து இடுக்கிக்கொள்ளவும்.
      </div>
  </div>
  <div className="clear"></div><hr />


  <div>
    <img src="assets/img/Praanaayaamam3.jpg" className="img2" />

    <div className="hint">வலது மூக்குத் துவாரத்தை, வலது
      கட்டை விரலால் அழுத்தி அடைக்கவும்.
    </div>
  </div>

  <div className="clear"></div><hr />
  <div>
    <img src="assets/img/Praanaayaamam4.jpg" className="img2" />
    <div className="hint"> வாயை நன்கு மூடி,
      சுட்டு விரல், நடு விரல்களை உள்ளே மடித்து,
      இட மூக்குத் துவாரம் வழியாக, வெளிக்காற்றை,
      முடிந்தவரை உள்ளிழுத்து நிறுத்தி,
      மோதிர, சுண்டு விரல்களால், இடமூக்குத் துவாரத்தையும்
      நன்கு அடைத்து ப்ராணாயாம மந்திரத்தை 3 முறை சொல்லவும்.
      </div>
  </div>
  <div className="clear"></div><hr />
  <div className="svk2">Pranayamam - Audio </div>
  <audio controls>
  <source src="https://www.brahminsnet.com/upakarma/audio/03-pranayamam1.ogg" type="audio/ogg" />
    <source src="https://www.brahminsnet.com/upakarma/audio/mp4/03-pranayamam1.mp4" type="audio/mp4" />
Your browser does not support the audio element.
</audio>
  <div className="prayogam">
    ஓம் பூ: ஓம் புவ: ஓகும்ஸுவ: ஓம் மஹ: ஓம் ஜன: ஓம் தப: ஓம் ஸத்யம்,
    தத்ஸவிதுர்வரேண்யம் பர்கோதேவஸ்யதீமஹி தியோயோந:ப்ரசோதயாத் ஓமாப: ஜ்யோதீரஸ:
   அம்ருதம் ப்ரஹ்மா பூர்புவஸ்ஸுவரோம்.
  </div>
<hr />
<div className="head2">ப்ராணாயாமம்</div>
<hr />
<div className="sans">
  ओं भू:। ओं भुव:। ओँसुव:। ओं मह:। ओं जन:। ओं तप:। ओँसत्यम्। ओं तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि । धियो यो न: प्रचोदयात्।
  ओमापो ज्योती रसोऽमूतं ब्रह्म भूर्भुवस्वरोम्।।
</div>
<hr />

<div>
  <img src="assets/img/praanaayaamam.gif" />
</div>


<div className="item">வடகலை ஆரம்பம்</div>
<hr />
<div>
  <img src="assets/img/kaikoopu.jpg" className="img2" />
  <div className="hint">கையைக் கூப்பிக்கொண்டு
    மந்திரங்களைச் சொல்ல ஆரம்பிக்கவும்.
  </div>
</div>
<hr />
<div className="svk2">VK-Begin - Audio </div>
    <audio controls>
    <source src="https://www.brahminsnet.com/upakarma/audio/04-vkbegining.ogg" type="audio/ogg" />
    <source src="https://www.brahminsnet.com/upakarma/audio/mp4/04-vkbegining.mp4" type="audio/mp4" />

  Your browser does not support the audio element.
  </audio>
<div className="prayogam">ஓம் அஸ்மத் குருப்யோ நம: ஸ்ரீமான் வேங்கட நாதார்ய:
   கவிதார்கிக கேசரி வேதாந்தாசார்ய வர்யோமே ஸந்நிதத்தாம்
   ஸதாஹ்ருதி குருப்ய: தத்குருப்யஸ்ச்ச நமோவாகம் அதீமஹே
   வ்ருணீமஹேச தத்ராத்யௌ தம்பதி ஜகதாம்பதி ஸ்வசேஷ
   பூதேநமயா ஸ்வீயை: ஸர்வபரிச்சதை:
  விதாதும் ப்ரீதமாத்மாநம் தேவ: ப்ரக்ரமதே ஸ்வயம்.</div>
  <hr />
<div className="sans">
  ओं अस्मत्गुरुभ्या नम:। श्रीमान् वेङ्कटनाथार्य: कवितार्किककेसरी। वेवान्ताचार्यवर्यो मे सिन्नधत्तां सदाहृदि|| गुरुभ्य: तद्गुरुभ्यश्च
  नमोवाकं अधीमहे। वृणीमहे च तत्राद्यौ दम्पती जगतां पती ।। स्वशेष भूतेन मया स्वीयै: सर्वपरिच्छदै: । विधातुं प्रीतमात्मानं
  देव: प्रक्रमते स्वयम् ।।

</div>
<hr />
<div className="item">தென்கலை, ஸ்மார்த்தா ஆரம்பம் வடகலை தொடர்ச்சி</div>
<div className="svk2">Suklambaradharam - Audio </div>
<audio controls>
<source src="https://www.brahminsnet.com/upakarma/audio/05-suklambara.ogg" type="audio/ogg" />
  <source src="https://www.brahminsnet.com/upakarma/audio/mp4/05-suklambara.mp4" type="audio/mp4" />
Your browser does not support the audio element.
</audio>
<div className="prayogam">
    சுக்லாம்பரதரம் விஷ்ணும் சசிவர்ணம் சதுர்புஜம் ப்ரஸன்னவதனம்
    த்யாயேது ஸர்வவிக்னோபசாந்தயே யஸ்யத்விரத வக்த்ராத்யா:
    பாரிஷத்யா:       பரஸ்சதம் விக்னம் நிக்னந்தி சததம்
    விஷ்வக்ஸேனம் தமாச்ரயே.
</div>
<hr />
<div className="sans">
  शुक्लाम्बरधरं विष्णुं शशिवर्णं चतुर्भुजम् । प्रसन्नवदनं ध्यायेत् सर्वविघ्नोपशान्तये ।। यस्यद्विरदवक्त्राद्या: पारिषद्या:
  पर:शतम् । विघ्नं निघ्नन्ति सततं विष्वसेनं तमाश्रये ।।

</div>
<hr />
<div>
  <img src="assets/img/Sankalpam.jpg" className="img2" />
  <div className="hint">வலது தொடையில் இடதுகைமேல்
    வலது கைவைத்து</div>
</div>

<div className="clear"></div><hr />
<div className="prayogam"> ஹரிரோம்தத்<br />
  ஸ்ரீ கோவிந்தா கோவிந்த கோவிந்தா அஸ்யஸ்ரீ பகவத: மஹாபுருஷ்ஸ்ய
   விஷ்ணோராஜ்ஞயா ப்ரவர்த்தமானஸ்ய ஆத்ய ப்ரஹ்மண:
   த்விதீயபரார்த்தே
  ஸ்ரீ ஸ்வேதவராஹ கல்பே வைவஸ்வத மன்வந்தரே
  கலியுகே ப்ரதமே பாதே
</div>
<div className="svk2">HariromTat - Audio </div>
<audio controls>
<source src="https://www.brahminsnet.com/upakarma/audio/06-gensankalpam.ogg" type="audio/ogg" />
  <source src="https://www.brahminsnet.com/upakarma/audio/mp4/06-gensankalpam.mp4" type="audio/mp4" />
Your browser does not support the audio element.
</audio>

<div className="svk">இந்தியாவில் இருப்பவர்கள்</div>
<div className="prayogam"> ஜம்பூத்வீபே பாரதவர்ஷே பரதக்கண்டே

</div>

<div className="svk">
    வெளிநாட்டில் இருப்பவர்கள் :
    த்வீபம் வர்ஷம் கண்டம் தெரியாதவர்கள் “விஷ்ணு” என்பதை
    உபயோகித்துக்கொள்ளலாம். அதாவது “விஷ்ணு த்வீபே”
    “விஷ்ணு வர்ஷே”, “விஷ்ணு கண்டே” என்று சொல்லலாம்

</div>
<hr />
<div className="svk">எல்லோரும் சொல்லவும்</div>
<div className="prayogam">சகாப்தே மேரோ: தக்ஷிணே பார்சவே அஸ்மின்
  வர்தமானானாம் வ்யவஹாரிகானாம் ப்ரபவாதீநாம் ஷஷ்டி
  ஸம்வத்ஸராணாம் மத்யே
  .....</div>
  <hr />
<div className="sans">
  हरि: ओं तत् (सत्) श्रीगोविन्द गोविन्द गोविन्द। अस्य श्रीभगवत: महापुरुषस्य श्रीविष्णो: आज्ञया प्रवर्तमानस्य अद्यब्रह्मण: द्वितीयपराार्धे
  श्रीश्वेतवराहकल्पे वैवस्त्वत मन्वन्तरे कळियुगे प्रथमेपादे जम्बूद्वीपे भारतवर्षे भरतखण्डे शकाब्दे मेरो: दक्षिणेपार्श्वे
  अस्मिन् वर्तमानानां व्यवहारिकाणां प्रभवादीनां षष्टिसंवत्सराणां मध्ये
</div>
<div className="clear"></div>

<hr />
<div className="head2">
  27-08-2026 க்கான ஸங்கல்பம்:
</div>
<div className="svk2">27-08-2026-Sankalpam - Audio </div>
  <audio controls>
  <source src="/assets/audio/27-08-2026.mp3" type="audio/mp3" />
Your browser does not support the audio element.
</audio>

<hr />

<div className="prayogam"> பராபவ நாம ஸம்வத்ஸரே - தக்ஷிணாயனே - வர்ஷ ருதௌ - சிம்ம மாஸே - சுக்ல பக்ஷே - சதுர்தசி (09.47 வரை) / பௌர்ணமாஸ்யாம் சுப திதௌ - குரு வாஸர யுக்தாயாம் - அவிட்டம் (ச்ரவிஷ்டா 27.41 வரை) நக்ஷத்ர யுக்தாயாம் - சோபன யோக யுக்தாயாம் - வணிஜ கரண யுக்தாயாம் - ஏவங்குண விசேஷண விசிஷ்டாயாம் அஸ்யாம் பௌர்ணமாஸ்யாம் சுப திதௌ ...
<hr />
</div>
<hr />
<div className="sans">
  पराभव नाम संवत्सरे दक्षिणयने - वर्ष ऋतौ सिंह मासे शुक्ल पक्षे 
पौर्णमास्यां / चतुर्दशी (09.47 am) शुभ तिथौ - वासर:
        गुरु वासर युक्तायां -
        श्रविष्टा (अविट्टम 27.41) नक्षत्र युक्तायां - शोभन योग युक्तायां - वणिज करण युक्तायां एवङ्गुण विशेषण विशिष्टायां अस्यां पौर्णमास्याम् शुभ
         तिथौ श्रीभगवदाज्ञया श्रीमन्नारायण प्रीत्यर्थं 
</div>


   <div className="mydiv">ஸ்ரீ-ம் (குறிப்பு:- இதுபோல் ஸ்ரீ-ம் என்று உள்ள இடங்களிலெல்லாம்
  <br /> வடகலையார் ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந் நாராயண ப்ரீத்யர்த்தம் என்றும்,
  <br /> தென்கலையார் ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீபகவத் கைங்கர்யம் என்றும்,
  <br /> ஸ்மார்த்தா மமோ பார்த்த சமஸ்த துரிதக்ஷய த்வாரா
  ஸ்ரீ பரமேஸ்வர ப்ரீத்யர்த்தம் என்றும் சொல்லிக் கொள்ளவும்) </div>
  <div className="clear"></div>

<hr />
<div className="head2">யஜ்ஞோபவீத தாரண ஸங்கல்பம்: </div>
<hr />
<div className="prayogam">மம ச்ரௌத ச்மார்த்த விதி விஹித நித்ய கர்மாநுஷ்டாந யோக்யதா ஸித்தியர்த்தம் ப்ரஹ்ம தேஜ: அபிவ்ருத்தியர்த்தம் யஜ்ஞோபவீத தாரணம்
  கரிஷ்யே. </div>
<div className="sans">
  मम श्रौतस्मार्त वितिविहित न्त्यिकर्म अनुष्टान योग्यता सिध्यर्थं ब्रह्मतेज:
  अभिवृद्धयर्थं यज्ञोपवीत धारणं करिष्ये।
</div>

<hr />
<div className="head2">யஜ்ஞோபவீத தாரண ந்யாஸம்:</div>
<hr />
<div>
  <img src="assets/img/Nyaasam1.jpg" className="img2" />

  <div className="hint">தலையைத் தொட்டு :</div>
  <div className="prayogam">யஜ்ஞோபவீத தாரண மந்த்ரஸ்ய ப்ரும்மா ருஷி:</div>
  <div className="sans">यज्ञोपवीत धारण मन्त्रस्य ब्रह्मा ऋषि:</div>
</div>

<div className="clear"></div><hr />

<div>
  <img src="assets/img/Nyaasam2.jpg" className="img2" />

  <div className="hint">மூக்கைத் தொட்டு :-</div>
  <div className="prayogam">‘அநுஷ்டுப் சந்த:’</div>
  <div className="sans">अनुष्टुप् छन्द:</div>

</div>
<div className="clear"></div><hr />



<div>
  <img src="assets/img/Nyaasam3.jpg" className="img2" />
  <div className="hint">மார்பைத் தொட்டு :-</div>
  <div className="prayogam">‘த்ரயீ வித்யா தேவதா’</div>
  <div className="sans">त्रयीविद्या देवता</div>

</div>
<hr />

<div>
  <img src="assets/img/Nyaasam4.jpg" className="img2" />

  <div className="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</div>
  <div className="prayogam"> ‘யஜ்ஞோபவீத தாரணே விநியோக:’</div>
  <div className="sans">यज्ञोपवीत धारणे विनियोग:</div>
</div>
<div className="head2">யஞ்ஞோபவீத தாரணம் </div>
<hr />
<img src="assets/img/Poonal-BrahmaMudichu.jpg" />
<hr />
<div>
    <img src="assets/img/poonal-position.jpg" className="img2" />

    <div className="hint">(பூணலில் ப்ரம்ம முடிச்சின் பசுமுகம் போன்ற இரண்டு
      நுனிகளுடன் கூடிய பாகம் கட்டைவிரலை பார்த்திருக்கும்படி வலது கையில் வைத்து,
  இடது கையால் பூணலின் கீழ்ப் பாகத்தின் உள்ளே வைத்து
  தளர்வின்றி பிடித்துக்கொண்டு மந்திரம் முடிந்தவுடன் தலையில் மாட்டி வலதுகை
  உள்ளே நுழைத்து இடது கையை வெளியே எடுத்துவிடவும்) </div>
</div>
<div className="clear"></div>
<hr />
<div>
  <img src="assets/img/insert-poonal.jpg" className="img2" />

<div className="prayogam">யஜ்ஞோபவீதம் பரமம் பவித்ரம் ப்ரஜாபதே:
  யத்ஸஹஜம் புரஸ்தாது ஆயுஷ்யம் அக்ரியம் ப்ரதிமுஞ்ச சுப்ரம்
  யஜ்ஞோபவீதம் பலமஸ்து தேஜ: </div>
</div>
<div className="clear"></div>
<div className="sans">
  यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
  अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
</div>

<div className="hint"> என்று சொல்லி போட்டுக்கொள்ளவேண்டியது.</div>
<div className="hint"> (என்று சங்கல்பித்து) இடுக்கு தர்பம் இருந்தால் அதை
  வடக்கே (இடது புறம்) சேர்க்கவும். </div>
  <div className="svk2">Yajgnopaveeta-Sankalpam - Audio </div>
<audio controls>
<source src="https://www.brahminsnet.com/upakarma/audio/17-yagnopaveethasankalpam.ogg" type="audio/ogg" />
  <source src="https://www.brahminsnet.com/upakarma/audio/mp4/17-yagnopaveethasankalpam.mp4" type="audio/mp4" />
Your browser does not support the audio element.
</audio>
<hr />
<div>
    <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
    <div className="hint">(கல்யாணமானவர்கள் மட்டும் 2வது பூணலுக்கு
       பவித்ரம் காதில் வைத்து
   ஆசமனம் பண்ணி பின் பவித்ரம்
  போட்டு ப்ராணாயமம்)</div>
  </div>
  <div className="clear"></div>
<hr />
<div>
<img src="assets/img/praanaayaamam.gif" />
</div>

<hr />
<div><img src="assets/img/Sankalpam.jpg" className="img2" />
<div className="prayogam">ஸ்ரீ-ம் க்ருஹஸ்த ஆச்ரமார்த்தம் த்விதீய யஜ்ஞோபவீத
   தாரணம் கரிஷ்யே. </div>
   <div className="sans">
      ग्रहस्त आश्रमार्थं िद्वतीय यज्ञोपवीत धारणं करिष्ये।
   </div>
   </div>
<hr />
<div>
  <img src="assets/img/poonal-position.jpg" className="img2" />

  <div className="hint">(பூணலில் ப்ரம்ம முடிச்சின் பசுமுகம் போன்ற இரண்டு
    நுனிகளுடன் கூடிய பாகம் கட்டைவிரலை பார்த்திருக்கும்படி வலது கையில் வைத்து,
இடது கையால் பூணலின் கீழ்ப் பாகத்தின் உள்ளே வைத்து
தளர்வின்றி பிடித்துக்கொண்டு மந்திரம் முடிந்தவுடன் தலையில் மாட்டி வலதுகை
உள்ளே நுழைத்து இடது கையை வெளியே எடுத்துவிடவும்) </div>
</div>
<div className="clear"></div>
<hr />
<div>
<img src="assets/img/insert-poonal.jpg" className="img2" />

<div className="prayogam">யஜ்ஞோபவீதம் பரமம் பவித்ரம் ப்ரஜாபதே:
யத்ஸஹஜம் புரஸ்தாது ஆயுஷ்யம் அக்ரியம் ப்ரதிமுஞ்ச சுப்ரம்
யஜ்ஞோபவீதம் பலமஸ்து தேஜ: </div>
</div>
<div className="clear"></div>
<div className="sans">
यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
</div>

<div className="hint"> என்று சொல்லி போட்டுக்கொள்ளவேண்டியது.</div>
<div className="hint"> (என்று சங்கல்பித்து) இடுக்கு தர்பம் இருந்தால் அதை
வடக்கே (இடது புறம்) சேர்க்கவும். </div>
<div className="svk2">Gruhasta-2nd-Poonal - Audio </div>
<audio controls>
<source src="https://www.brahminsnet.com/upakarma/audio/18-2ndpoonal.ogg" type="audio/ogg" />
  <source src="https://www.brahminsnet.com/upakarma/audio/mp4/18-2ndpoonal.mp4" type="audio/mp4" />
Your browser does not support the audio element.
</audio>
<hr />



<div className="hint"> பின் க்ருஹஸ்தாள் ப்ருஹ்மச்சாரி அனைவரும் </div>
<div className="prayogam">"உபவீதம் பின்னதந்தும் ஜீர்ணம் கஸ்மலதூஷிதம்
  விஸ்ருஜாமி ஜலேப்ரஹ்மண்ணு வர்ச்ச: தீர்காயு: அஸ்துமே"</div>
  <div className="sans">
      उपवीतं भिन्नतन्तुं जीर्णं कश्मलदूषितम्।<br />
      विसृजामि जले ब्रह्मन् वर्च: दीर्घायु: अस्तु मे।।
  </div>
  <div className="svk2">Remove Old Poonal - Audio </div>
  <audio controls>
  <source src="https://www.brahminsnet.com/upakarma/audio/19-removepoonal.ogg" type="audio/ogg" />
    <source src="https://www.brahminsnet.com/upakarma/audio/mp4/19-removepoonal.mp4" type="audio/mp4" />
  Your browser does not support the audio element.
  </audio>
<hr />

<div>
  <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
<div className="hint"> என்று சொல்லி பழைய பூணலை எடுத்துவிட்டு பவித்ரம்
  காதில் வைத்து ஆசமனம் பண்ணவும். </div>
  </div>
  <img src="assets/img/achamanam.gif" />
  <div className="mydiv">
  <div className="svk">தலை ஆவணியவிட்டம் பண்ணும் ப்ரம்மச்சாரிகளுக்கு
  கமோகார்ஷீத் ஜபம் கிடையாது.</div>
</div>
<div className="clear"></div>
<br />
<hr />
<div className="head2">காமோ கார்ஷீத் ஜபம்</div>
<hr />

<div className="hint">பவித்ரம் காதில் இருந்தால் போட்டுக்கொள்ளவும்.</div>
  <hr />

   <div>
    <img src="assets/img/Sankalpam.jpg" className="img2" />
    <div className="hint">வலது தொடையில் இடதுகைமேல் வலது கைவைத்து</div>
    </div>

<div className="prayogam"> “ ஸ்ரீ-ம்| தைஷ்யாம் பௌர்ணமாஸ்யாம்
  அத்யாய உத்ஸர்சன அகரண ப்ராயச்சித்தார்த்தம்
  </div><div className="hint" style={{"float": "left"}}>108 பண்ண :</div>
  <div className="prayogam">அஷ்டோத்ர சத ஸங்க்யயா</div>
 <div className="hint" style={{"float": "left"}}> 1008க்கு: </div>
 <div className="prayogam">அஷ்டோத்ர ஸஹஸ்ர ஸங்க்யயா
  காமோ கார்ஷீத் மந்யுர கார்ஷீத் இதி மந்த்ர ஜபம் கரிஷ்யே." </div>
  <div className="clear"></div>
  <div className="sans">
      तैष्यां पौर्णमास्यां अद्धयाय उत्सर्जन अकरण प्रायश्चित्तार्थं अष्टोत्तर शत(108) / सहस्र(1008)
      सङ्ख्या कामोकार्षीत् मन्युरकार्षीत् इति महामन्त्र जपं करिष्ये।
  </div>
  <div className="svk2">Kamokarsheet-Sankalpam - Audio </div>
  <audio controls>
  <source src="https://www.brahminsnet.com/upakarma/audio/11-kamosankalpatk108.ogg" type="audio/ogg" />
    <source src="https://www.brahminsnet.com/upakarma/audio/mp4/11-kamosankalpatk108.mp4" type="audio/mp4" />
  Your browser does not support the audio element.
  </audio>
  <div className="hint"> என்று ஸங்கல்பித்துக் கொண்டு </div>
   <div className="mydiv">வ.க. மட்டும் "காமோகார்ஷீத் ஜப கர்மாக்யம் கர்மஸ்வஸ்மை ஸ்வப்ரீதயே
  பகவான் ஸ்வயமேவ காரயதி" என்று
  ஸாத்விக த்யாகமும் பண்ணிக் கொண்டு</div>
  <div className="hint">அனைவரும்
  ஸங்கல்பித்தபடி 108 அல்லது 1008 தடவை </div>
  <hr />
  <div className="prayogam">"காமோகார்ஷீத் மந்யுர கார்ஷீத்" </div>
  <div className="sans">कामोकार्षीत् मन्युरकार्षीत्</div>
  <div className="svk2">Kamokarsheet-Japam-9-Times - Audio </div>
  <audio controls>
  <source src="https://www.brahminsnet.com/upakarma/audio/12-kamojapam9times.ogg" type="audio/ogg" />
    <source src="https://www.brahminsnet.com/upakarma/audio/mp4/12-kamojapam9times.mp4" type="audio/mp4" />
  Your browser does not support the audio element.
  </audio>
  <hr />
  <div className="hint">என்ற மந்திரத்தை ஜபிக்கவும். ஜபம் ஆனதும்
  எழுந்திருந்து ஸேவித்து </div>
  <div className="prayogam">"காமோகார்ஷீத் மந்யுரகார்ஷீத் நமோநம:“ </div>
  <div className="sans">कामोकार्षीत् मन्युरकार्षीत् नमो नम:|</div>

  <div className="hint">என்று ஸேவித்து அபிவாதனமும் பண்ணிவிட்டு </div>
  <div className="svk2">Kamokarsheet-Upastanam - Audio </div>
  <audio controls>
  <source src="https://www.brahminsnet.com/upakarma/audio/13-kamoupasthan.ogg" type="audio/ogg" />
    <source src="https://www.brahminsnet.com/upakarma/audio/mp4/13-kamoupasthan.mp4" type="audio/mp4" />
  Your browser does not support the audio element.
  </audio>
  <div className="mydiv">வ.க. மட்டும் கைகூப்பிக் கொண்டு பகவாநேவ காமோகார்ஷீத்
  ஜப கர்மாக்யம் கர்மஸ்வஸ்மை ஸ்வப்ரீதயே
  பகவான் ஸ்வயமேவ காரிதவான் என்று ஸாத்விக த்யாகமும்
  பண்ணிக் கொள்ள வேண்டியது </div>

  <div className="hint">தர்பணத்துக்கு வேறு பவித்ரம் இருந்தால் தற்போது
  பவித்ரத்தை பிரித்துப்போட்டு அல்லது பத்திரமாக
  எடுத்துவைத்துக்கொண்டு அனைவரும் ஆசமனம் பண்ணிவிடவும். </div>

  <div className="mydiv">
    <div className="svk">(ப்ரஹ்மசாரிகள் க்ஷவரம்) அனைவரும் தீர்த்தமாடி பட்டோ,
  மடியோ உடுத்தி (12) திருமண் இட்டுக்கொண்டு மாத்யான்னிகம் பண்ணிவிட்டு
  காண்டருஷி தர்பணம்.</div>
 <div className="svk"> முடிந்தவர்கள் ஸ்நாந மஹா ஸங்கல்பம் பண்ணிக்கொண்டு
  மறுபடி ஸ்நாநம், மாத்யாஹ்நிகம், பெருமாள் ஆராதனம் (தீர்த்தம் மட்டும்
  எடுத்துக்கொள்ளாமல்)
  குளம், ஆற்றுக் சென்று அனைவருடன் சேர்ந்து காண்டரிஷி தர்பணம்.
   </div>
</div>
<div className="clear"></div>

<hr />
<div className="head2">காண்டருஷி தர்பணம்</div>
<hr />
<div className="hint">பவித்திரத்துடன் ப்ராணாயாமம்.</div>
<hr />
<div>
  <img src="assets/img/praanaayaamam.gif" />
</div>
  <div className="prayogam">ஓம் பூ: ஓம் புவ: ஓகும்ஸுவ: ஓம் மஹ:
  ஓம் ஜன: ஓம் தப: ஓம் ஸத்யம், தத்ஸவிதுர்வரேண்யம்
  பர்கோதேவஸ்யதீமஹி தியோயோந:ப்ரசோதயாத் ஓமாப:
  ஜ்யோதீரஸ: அம்ருதம் ப்ரஹ்மா பூர்புவஸ்ஸுவரோம்.</div>

  <div className="hint">(நேரமிருந்தால் முன் பக்கத்தில் உள்ளபடி
   "ஓம் அஸ்மத் குருப்யோ நம:" முதல் இந்த தேதிக்குரிய
   ஸங்கல்பம் வரை முழுமையாகச் சொல்லவும்
  அல்லது</div>
<div>
      <img src="assets/img/Sankalpam.jpg" className="img2" />
      <div className="hint">வலது தொடையில் இடதுகைமேல் வலது கைவைத்து</div>
    </div>
    <div className="clear"></div>
    <div className="prayogam">அத்ய பூர்வோக்த ஏவங்குண விசேஷண விசிஷ்டாயாம்
  அஸ்யாம் பௌர்ணமாஸ்யாம் சுபதிதௌ ஸ்ரீ-ம் ச்ராவண்யாம் பௌர்ணமாஸ்யாம்
  அத்யாய உபாகர்மா
  கரிஷ்யே! ததங்கம் காவேரீ ஸ்நாநமஹம் கரிஷ்யே. ததங்கம் காண்டருஷி
  தர்பணம் கரிஷ்யே. <span style={{"backgroundColor": "yellow"}}> (ப்ரஹ்மசாரிகள் மட்டும்) ததங்கம் மௌஞ்சி
  அஜின தண்ட தாரணாநிச கரிஷ்யே.</span></div>
  <div className="sans"> </div><hr />
<div className="mydiv">
  <div className="hint">வ.க:- "பகவாநேவ ஸ்வசேஷ பூதமிதம் அத்யாய உபாகர்மாக்யம்
  கர்ம ஸ்வஸ்மை ஸ்வப்ரீதயே பகவாந் ஸ்வயமேவ காரயதி </div>
<hr />
  <div className="hint">ப்ரம்மச்சாரிகள் மௌஞ்சி, மான்தோல், தண்டம் தரிக்கவும்:
   மௌஞ்சியைக் கட்டிக்கொள்ளவும்</div>
   </div>
   <br />
   <hr />
   <div className="head2">முஞ்சை கயிறு அணிய</div>
   <hr />
<div>
    <img src="assets/img/Mounji.jpg" className="img1" />
    <div className="prayogam">இயம் துருக்தாத் பரிபாதமாநா சர்ம வரூதம் புநதீந:
  ஆகாத் ப்ராணாபாநாப்யாம் பலமாபரந்தி ப்ரியா தேவநாம் ஸுபகா மேகலேயம்.
  ருதஸ்ய
  கோப்த்ரி தபஸ: பரஸ்பீ க்நதீரக்ஷ: ஸஹமாநா அராதீ: ஸாநஸ்ஸமந்தம்
  அநுபரீஹி பர்த்ரயா பர்தாரஸ்தே மேகலே மாரிஷாம! என்று சொல்லி மௌஞ்சியைக்
  கட்டிக்கொள்ளவும்.</div>
  <div className="sans">
      इयं दुरुक्तात् परिबाधमाना शर्म वरूथं पुनतीन: आगात् ।<br />
       प्राणाभानाभ्यां बलं आभरन्ती प्रिया देवानां सुभगा मेखला इयम् । <br />
ऋतस्य गोप्त्री तपस: परस्पी घ्नती रक्ष: सहमाना अराती:।<br />
सान: समन्तं अनू परीहि भद्रया भर्तारस्ते मेखले मारिषाम ।।

  </div>
  </div>
  <div className="clear"></div>
  <div className="head2">அஜிநம் (மான் தோல் அணிய)</div>
<div>
    <img src="assets/img/Ajinam.jpg" className="img1" />
    <div className="prayogam">மித்ரஸ்ய சக்ஷு: தருணம் பலீய: தேஜ: யசஸ்வீ
  ஸ்தவிரம் ஸமித்தம் அநாஹநஸ்யம் வஸநம் ஜரிஷ்ணு பரீதம்
  வாஜி அஜிநம் ததேஹம்</div>
  <div className="sans">
      मित्रस्य चक्षु: धरुणं बलीय: तेज: यशस्वि स्थविरं समिद्धं । <br />
      अनाहनस्यं वसनं जरिष्णु परीदं वाजि अजिनं दधेहम् ।
  </div>
</div>
<div className="clear"></div>
<div className="head2">தண்ட தாரணம்:</div>
<div>
    <img src="assets/img/Dhandam.jpg" className="img1" />

    <div className="prayogam">ஸுச்ரவ: ஸுச்ரவஸம் மாகுரு யதாத்வம் ஸுச்ரவ:
  ஸுச்ரவா: அஸி ஏவமஹம் ஸுச்ரவ: ஸுச்ரவா: பூயாஸம் யதாத்வம்
  ஸுச்ரவ: தேவாநாம் நிதிகோப:
  அஸி ஏவமஹம் ப்ராஹ்மணாநாம் ப்ரஹ்மண: நிதிகோப: பூயாஸம்.</div>
  <div className="sans">
      सुश्रव: सुश्रवसं माकुरु यथात्वं <br />
      सुश्रव: सुश्रवा: असि एवमहं <br />
      सुश्रव: सुश्रवा: भूयासं यथात्वं<br />
      सुश्रव: देवानां निधिगोप: असि एवमहं<br />
      ब्राह्मणानां ब्रह्मण: निधिगोप: भूयासम् ।।
  </div>
</div>
<div className="clear"></div>
<div className="svk">மௌஞ்சி தண்டம் இவைகளை தரித்துக் கொண்டு மீண்டும்
   (முடிந்தால்) எல்லோரும் ஸ்நாநம் பண்ணிவிட்டு முன் பக்கங்களில்
   கொடுக்கப்பட்டுள்ளபடி யஜ்ஞோபவீத தாரணம் பண்ணிக்கொண்டு
   பின் காண்டருஷி தர்பணம் பண்ணவும்.<br />
   <hr />
   ஆறு குளங்களுக்குச் செல்ல முடியாதவர்கள், நன்கு ஜலம் ஓடும்படியான
  இடத்திற்கு ஜலம், அக்ஷதை போன்றவற்றைக் கொண்டு வைத்துக்கொண்டு
  தர்பணம் பண்ணவும்.</div>
  <hr />

  <div className="head2">காண்ட ருஷி தர்பணம்</div>
  <hr />

  <div className="hint">காண்டருஷி தர்பணம் பண்ண தீர்த்தம் அக்ஷதை (எள்)
  இவைகளை தயாராக எடுத்து வைத்துக்கொண்டு கிழக்குமுகமாக குந்தி
  உட்கார்ந்து பூணலை
  மாலையாகப் போட்டுக்கொண்டு 2 கட்டைவிரல்களாலும் பிடித்துக்
   கொண்டு பண்ணவும். (படம் பார்க்க)</div>
   <hr />

  <div>
      <img src="assets/img/DevaTheertham1.jpg" className="img1" />


      <div className="hint"><span style={{"backgroundColor": "yellow"}}> 1.தேவ தீர்த்தம் :</span> இரு கைகளில் விரல் நுனிகளின்
  வழியாக தேவர்களுக்கும்</div>
</div>
<div className="clear"></div>
<hr />

<div>
    <img src="assets/img/PithruTheertham2.jpg" className="img1" />

    <div className="hint"><span style={{"backgroundColor": "yellow"}}> 2. பித்ரு தீர்த்தம் :</span> வலது கை கட்டைவிரல்
  வழியாக பித்ருக்களுக்கும்</div>
</div>
<div className="clear"></div>
<hr />
<div>
    <img src="assets/img/BrahmaTheertham1.jpg" className="img1" />

<div className="hint"><span style={{"backgroundColor": "yellow"}}>3. ப்ரஹ்ம தீர்த்தம் :</span> இரு கை முன்பகுதியை உயரே
   தூக்கி மணிக்கட்டு வழியாக ப்ரஹ்மாவுக்கும்</div>

</div>
<div className="clear"></div>
<hr />
<div>
  <img src="assets/img/RushiTheertham1.jpg" className="img1" />
<div className="hint"><span style={{"backgroundColor": "yellow"}}>4. ருஷி தீர்த்தம் : </span>இரு கைகளின் மத்தியில்
  சுண்டு விரலுக்குக் கீழ் பகுதியில் துவாரம் ஏற்படுத்தி அதன் வழியாக ருஷிகளுக்கும்
  தீர்த்தம் விட்டு தர்பணம் செய்யவேண்டும்</div>
</div>
<div className="clear"></div>
<hr />

<div className="hint">ஒவ்வொரு தர்பணமும் மும்மூன்று முறை
  பண்ணவேண்டும்
  </div>
  <br />
  <hr />
  <div>
    <img src="assets/img/RushiTheertham1.jpg" className="img1" />
   <span style={{"backgroundColor": "yellow"}}>ருஷி தர்பணம் பூணல்
     மாலையாக அணியவும்</span></div>
<div className="clear"></div>
<hr />
<div className="prayogam">
  1.ப்ராஜாபதிம் காண்டருஷிம் தர்பயாமி <br />
  2.ஸோமம் காண்டருஷிம் தர்பயாமி <br />
  3.அக்நிம் காண்டருஷிம் தர்பயாமி <br />
  4.விச்வான்தேவான் காண்டருஷீன் தர்பயாமி
</div>
<div className="sans">
    प्रजापतिं काण्डऋषिम् तर्पयामि ।<br />
    सोमं काण्डऋषिम् तर्पयामि ।<br />
    अग्निं काण्डऋषिम् तर्पयामि ।<br />
    विस्वान् देवान् काण्डऋषिम् तर्पयामि ।
</div>
<hr />
<div>
    <img src="assets/img/DevaTheertham1.jpg" className="img1" />
<div className="hint">தேவ தர்பணம் பூணல் உபவீதம் (நேராகப்)
  போட்டுக்கொள்க
</div>
</div>
<div className="prayogam">
  5.ஸாம்ஹிதீர் தேவதா: உபநிஷத: தர்பயாமி <br />
  6.யாஜ்ஞிகீர் தேவதா: உபநிஷத: தர்பயாமி <br />
  7.வாருணீர் தேவதா: உபநிஷத: தர்பயாமி</div>
  <div className="sans">
      साँहितीर्देवता: उपनिषत: तर्पयामि ।<br />
      याज्ञिकी: देवता: उपनिषत: तर्पयामि ।<br />
      वारुणी: देवता: उपनिषत: तर्पयामि ।
    </div>
    <hr />
<div>
    <img src="assets/img/BrahmaTheertham1.jpg" className="img1" />
    <div className="hint">
ப்ரஹ்ம தர்பணம் பூணல் உபவீதம் (நேராகப்) போட்டுக்கொள்க </div>
</div>
<div className="clear"></div>
<div className="prayogam"> 8.ப்ரஹ்மாணம் ஸ்வயம்புவம் தர்பயாமி</div>
<div>
    <div className="sans">
        ब्रह्माणम् स्वयम्भुवम् तर्पयामि ।
      </div>
      <hr />
    <img src="assets/img/DevaTheertham1.jpg" className="img1" />
<div className="hint"> தேவ தர்பணம் பூணல் உபவீதம் (நேராகப்) போட்டுக்கொள்க
</div>
</div>
<div className="clear"></div>


<div className="prayogam"> 9.ஸதஸஸ்பதிம் தர்பயாமி </div>

<div className="prayogam">
  10.ருக் வேதம் தர்பயாமி <br />
  11.யஜூர் வேதம் தர்பயாமி <br />
  12. ஸாம வேதம் தர்பயாமி<br />
  13.அதர்வண வேதம் தர்பயாமி <br />
  14.இதிஹாஸம் தர்பயாமி <br />
  15.புராணம் தர்பயாமி <br />
  16.கல்பம் தர்பயாமி</div>
  <div className="sans">
      सदसस्पतिं तर्पयामि ।<br />
      ऋग्वेदं तर्पयामि ।<br />
      यजुर्वदं तर्पयामि ।<br />
      सामवेदं तर्पयामि ।<br />
      अधर्ववेदं तर्पयामि ।<br />
      इतिहासं तर्पयामि ।<br />
      पुराणं तर्पयामि ।<br />
      कल्पं तर्पयामि ।
    </div>
    <hr />
<div>
        <img src="assets/img/PithruTheertham2.jpg" className="img1" />
<div className="hint"> தகப்பனார் இல்லாதவர்கள் மட்டும்
  பூணலை ப்ராசீனாவிதமாக போட்டுக் கொண்டு
  பித்ரு தர்பணம் பூணல் ப்ராசீனாவீதமாகப் போட்டுக்கொள்க
  எள், அக்ஷதை கலந்து கட்டைவிரல் வழியாக
  தீர்த்தம் விடவும் மும்மூன்று முறை</div>
</div>
<div className="prayogam">17.ஸோம: பித்ருமாந் யம:
  அக்கிரஸ்வாந் அக்நி: கவ்யவாஹன: இத்யாதய:
   ஏபிதர: தாந்பித்ரூந் தர்பயாமி <br />
   18.ஸர்வாந் பித்ரூந் தர்பயாமி<br />
  19.ஸர்வ பித்ரு பத்நீ: தர்ப்பயாமி <br />
  20.ஸர்வ பித்ருகணா: தர்பயாமி <br />
  21.ஸர்வ பித்ரு கணபத்நீ: தர்ப்பயாமி <br />
  22.ஊர்ஜம் வஹந்தீ: அம்ருதம்
  க்ருதம்பய: கீலாலம் பரிஸ்ருதம் ஸ்வதாஸ்த்த
  தர்ப்பயதமே அஸ்மத் பித்ரூநு. <br />
  திருப்யத த்ருப்பயத ! த்ருப்பயத.</div>
  <div className="sans">
      (प्राची)- सोम:पितृमान् यम: अङिगरस्वान् <br />
      अग्नि: कव्यवाह: इत्यादय: येपितर: <br />
      तान् पितृृन् तर्पयामि ।<br />
      सर्वान् पितृन् तर्पयामि ।<br />
      सर्वपितृगणा: तर्पयामि ।<br />
      सर्वपितृपत्नी: तर्पयामि।<br />
      सर्वपितृ गणपत्नी: तर्पयामि ।<br />
      उूर्जंवहन्ती: अमृतं घृतं  पय: <br />
      कीलालं परिसृतं स्वधास्थ <br />
      तर्पयतमे पितृन् ।<br />
      तृप्यत । तृप्यत । तृप्यत ।।<br />
      उपवीति।
    </div>
<hr />
<div>
  <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
<div className="hint">என்று தர்பித்தபின் பூநூலை உபவீதமாகப்
  போட்டுக்கொண்டு பவித்ரம் காதில் வைத்து
  ஆசமனம் பண்ணவேண்டியது.</div>
  </div>
  <div className="clear"></div>
  <hr />
  <div>
      <img src="assets/img/achamanam.gif" />
    </div>
    <hr />
<div className="head2">வேதாரம்பம்</div>
<div>
    <img src="assets/img/Sankalpam.jpg" className="img2" />
    <div className="hint">
  கிழக்குமுகமாக அமர்ந்து பவித்ரம் போட்டுக்கொண்டு
  வலது தொடையில் இடதுகைமேல் வலது கைவைத்து
</div>
<div className="prayogam">"வேதாரம்பம் கரிஷ்யே"</div>
<div className="sans">वेदारम्भं करिष्ये ।
  </div>
<div className="hint">என்று ஸங்கல்பம் செய்து கொண்டு
  கீழே உள்ள வேத மந்திரங்களை
  (தெரிந்தால் ஸ்வரத்துடன்) ஜபிக்கவும்.</div>
</div>
<div className="clear"></div>

<div className="prayogam"> “ஹரி:ஓம் அக்நிமீளே ப்ரோஹிதம் யக்ஞஸ்ய
   தேவம்ருத்விஜம் ஹோதாரம் ரத்நதாதமம் ஹரி:ஓம்
   (ருக் வேதம்) <br />
   ஹரி: ஓம் இஷேத்வா ஊர்ஜேத்வா
  வாயவஸ்த்த உபாயவஸ்த தேவோவ: ஸவிதா ப்ரார்ப்பயது
   ச்ரேஷ்டதமாய கர்மணே ஹரி: ஓம்
   (யஜூர் வேதம்) <br />
   ஹரி: ஓம் அக்நஆயாஹி வீதயே க்ருணாநோ
  ஹவ்யதாதயே நிஹோதா ஸத்ஸிபர்ஹிஷி ஹரி: ஓம்
  (ஸாம வேதம்) <br />
  ஹரி: ஓம் சந்நோதேவீ: அபிஷ்டயே
  ஆபோபவந்து பீதயே ச(ம்)யோரபிஸ்ரவந்துந:
  ஹரி: ஓம் (அதர்வ வேதம்)”
</div>
<div className="sans">
    हरि: ॐ। अग्निमीळे पुरोहितं - यज्ञस्य - देवमृत्विजम् ।
    होतारं - रत्नधातमं । हरि: ॐ।<br /><hr />
    हरि: ॐ। इषेत्वा - उूर्जेत्वा - वायवस्थ - उपायवस्थ - देवोव: - सविता -
    प्रार्पयत् श्रेष्टतमाय - कर्मणे । हरि: ॐ।<br /><hr />
    हरि: ॐ। अग्न आयाहि - वीतये - गृणान: - हव्यदातये ।
    निहोता - सत्सि - बर्हिषि । हरि: ॐ।<br /><hr />

    हरि: ॐ। शन्नोदेवेरभिष्टये - आपोभवन्तु - पीतये - शँयोरभिस्रवन्तुन: । हरि: ॐ।
  </div>
<div className="hint">வேதாரம்பம் முழுமையும் சொல்வதானால்
  நிறைய நேரம் ஆகும். விருப்பம் உள்ளவர்கள்
  கீழ்க்கண்ட வீடியோக்கனை ஓடச்செய்து முழுமையாக ஜபம்
  செய்யலாம்.
   </div>
<hr />
<div className="mydiv">வடகலையார்:
<div className="prayogam">பகவாநேவ ...ஸ்வசேஷ பூதமிதம் அத்யாய
   உபாகர்மாக்யம் கர்ம ஸ்வஸ்மை ஸ்வப்ரீதயே
   பகவாந் ஸ்வயமேவ காரிதவாந்.</div>
<div className="hint"> என்று ஸாத்வீக த்யாகம் சொல்லவேண்டியது.</div>
</div>
<hr />

        <img src="assets/img/shastanga-namaskaram.JPG" className="img1" />

        <div className="hint">  எழுந்திருந்து ஸேவித்து </div>
        <div className="clear"></div><hr />
      <img src="assets/img/abhivathi.jpg" className="img1" />

      <div className="hint">
        அபிவாதனம் பண்ணவேண்டியது.
  <br />பவித்ரம் பிரித்துப்போட்டு ஆசமனம் பண்ணறது. </div>
  <div className="clear"></div><hr />





<div>
<img src="assets/img/kaikoopu.jpg" className="img2" />
<div className="hint">கையைக் கூப்பிக்கொண்டு சொல்லவும்</div>
</div>
<div className="clear"></div><hr />

  <div className="svk">
    அனைவரும் சொல்லலாம்.
  </div>
<div className="prayogam">
“காயேன வாசா மனஸா இந்த்ரியைர்வா புத்யா ஆத்மனாவா ப்ரஹ்ருதே: ச்வபாவாது கரோமி
  யத்யது ஸகலம் பரஸ்மை ஸ்ரீமன்நாராயணாயேதி ஸமர்பயாமி"
     .” ஸர்வம் ஸ்ரீக்ருஷ்ணார்ப்பணமஸ்து. அச்யுதப் ப்ரீயதாம்.
</div>
<div className="sans">
कायेन वाचा मनसेन्द्रियैर्वा ।
<br /> बुद्ध्यात्मना वा प्रकृतिस्वभावात् ।
<br /> करोमि यद्यत्सकलं परस्मै ।
<br /> नारायणयेति समर्पयामि ॥
</div>
<hr />
<div className="hint"> பொதுவான இடத்தில் சென்று உபாகர்மா முடித்து
  ஆத்துக்கு வருபவர்களுக்கு ஆரத்தி எடுப்பது வழக்கம்.
  <br />
  <hr />
  இத்துடன் ஆவணியவிட்டம் முற்றுப்பெற்றது.
  </div>
<hr />
<div className="svk">பெருமாள் ஸேவித்து, பெரியவாளையும் ஸேவிக்கறது.</div>
<div className="item"> மனம் நிறைந்த வாழ்த்துக்கள், குடும்பத்தாருடன், நோயற்ற வாழ்வு, குறைவற்ற செல்வம்,
நீண்ட ஆயுளுடன், நிம்மதியாக வாழ எம்பெருமான் அருள்புரிய, ஆசீர்வாதங்களுடன்
அல்லது வாழ்த்துக்களுடன் - வாத்யார்!
<br />
தாஸன்,<br />
Dr.NVS </div>
<hr />

   
</div>
<div className="tab-section my-8">
<h2 className="text-2xl font-bold mb-4">English</h2>
  <div className="svk">Achamanam</div>
  <div className="hint">
    </div>
  <hr />
  <div>
    <img src="assets/img/new-achamanam.gif" />
  </div>
  <div className="hint">Achamanam and Praanayaamams are frequent
  actions done several times in any vaideeka karma. So,kindly use the below
  instructions and bring it in practice doing without any guide.
    </div>
    <hr />
  <div className="sans">
    ओं अच्युताय नम:। ओं अनन्ताय नम:। <br />
    ओं गोविन्दााय नम:।<br />
    <div className="grid">
      <div className="flex flex-row flex-wrap">
        <div className="sans">ओं केशवाय नम:। </div>
        <div className="sans">नारायणाय नम:।</div>
      </div>
      <div className="flex flex-row flex-wrap">
        <div className="sans">माधवाय नम:।</div>
        <div className="sans">गोविन्दाय नम:।</div>
      </div>
      <div className="flex flex-row flex-wrap">
        <div className="sans">विष्णवे नम:। </div>
        <div className="sans">मधुसूदनाय नम:।
         </div>
      </div>
      <div className="flex flex-row flex-wrap">
        <div className="sans"> त्रिविक्रमाय नम:। </div>
        <div className="sans">वामनाय नम:।
          </div>
      </div>
      <div className="flex flex-row flex-wrap">
        <div className="sans">श्रीधराय नम:। </div>
        <div className="sans">हृषीकेशाय नम:।
          </div>
      </div>
      <div className="flex flex-row flex-wrap">
        <div className="sans">पद्मनाभाय नम:। </div>
        <div className="sans">दामोदराय नम:।</div>
      </div>
    </div>
     </div>
  <hr />
  <div>
      <img src="assets/img/Praanaayaamam1.jpg" className="img2" />

      <div className="hint">Sit facing East, insert two short dharbhams as seat under your legs
        </div>
    </div>
    <hr />
    <div>
      <img src="assets/img/Praanaayaamam2.jpg" className="img2" />

      <div className="hint">Wear a pavithram made with two dharbhams in the Rt ring finger
and fold two extra dharbhams along with it.
        </div>
    </div>
    <div className="clear"></div><hr />


    <div>
      <img src="assets/img/Praanaayaamam3.jpg" className="img2" />

      <div className="hint" style={{"height": "50px"}}>Press the rt nostrils with rt thumb
      </div>
    </div>

    <div className="clear"></div><hr />
    <div>
      <img src="assets/img/Praanaayaamam4.jpg" className="img2" />
      <div className="hint"> Fold both index and middle fingers towards inside, shut the mouth, inhale outside air through left nostril to fill your lung
then shut the lt nostrils also using ring and little finger.
<br />recite the below manthra thrice to complete one praaNaayaama
        </div>
    </div>
    <div className="clear"></div><hr />

    <div className="prayogam">Om bhoohu Om bhuvaha O(gu)m suvaha Om mahaha Om janaha Om thapaha Om sathyam tatsavidhurvareaNyam bhargodhevasya dheemahi
      dhiyoyonah prachodhayaadh Omaapaha jyotheerasaha amrutham brahma bhoor bhuva suvar Om</div>
    <div className="hint">
    The inner air should be released little by little and at the end touch the rt ear by little finger while
saying the end part of the manthra 'Om'. </div>
  <hr />
  <div className="head2">ப்ராணாயாமம்</div>
  <hr />
  <div className="sans">
    ओं भू:। ओं भुव:। ओँसुव:। ओं मह:। ओं जन:। ओं तप:। ओँसत्यम्। ओं तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि । धियो यो न: प्रचोदयात्।
    ओमापो ज्योती रसोऽमूतं ब्रह्म भूर्भुवस्वरोम्।।
  </div>
 <hr />

  <div>
    <img src="assets/img/praanaayaamam.gif" />
  </div>


  <div className="item">Vada Kalai To Start</div>
<hr />
  <div>
    <img src="assets/img/kaikoopu.jpg" className="img2" />
    <div className="hint">Keep both hands as shown  doing Namaskaram
    </div>
  </div>
<hr />

  <div className="prayogam">Om asmath gurubhyo namaha.
Sreemaan venkata naathaaryaha Kavithrkika kesari
Vedaanthaacharya varyome; Sannidhattham sadhahrudhi.
Gurubhyaha - thath gurubhyascha namovakam atheemahe
Vruneemahecha thathraadhyau dhampathi jagadhampathi
Swasesha bhuuthena maya sveeyai:(hi) sarva parichathai:(hi)
Vidhathum preetam aatmaanam deva:(ha) prakramadhe swayam.</div>
    <hr />
  <div className="sans">
    ओं अस्मत्गुरुभ्या नम:। श्रीमान् वेङ्कटनाथार्य: कवितार्किककेसरी। वेवान्ताचार्यवर्यो मे सिन्नधत्तां सदाहृदि|| गुरुभ्य: तद्गुरुभ्यश्च
    नमोवाकं अधीमहे। वृणीमहे च तत्राद्यौ दम्पती जगतां पती ।। स्वशेष भूतेन मया स्वीयै: सर्वपरिच्छदै: । विधातुं प्रीतमात्मानं
    देव: प्रक्रमते स्वयम् ।।

  </div>
  <hr />
  <div className="item">Manthram Common for All </div>

  <div className="prayogam">
      Suklambharadharam vishnum sasivarnam chathur bhujam
Prasanna vadhanam dhyayedh sarva vigna upasaanthaye.
Yasyadhvradha vakrathyaha paarishathyaaha parassadham
Vignam nignandhi sadhadham vishvaksenam tham aashraye.
  </div>
  <hr />
  <div className="sans">
    शुक्लाम्बरधरं विष्णुं शशिवर्णं चतुर्भुजम् । प्रसन्नवदनं ध्यायेत् सर्वविघ्नोपशान्तये ।। यस्यद्विरदवक्त्राद्या: पारिषद्या:
    पर:शतम् । विघ्नं निघ्नन्ति सततं विष्वसेनं तमाश्रये ।।

  </div>
<hr />
  <div>
    <img src="assets/img/Sankalpam.jpg" className="img2" />
    <div className="hint">keep the left hand as open in right thigh, place the right hand
on it as closing</div>
  </div>

  <div className="clear"></div><hr />
  <div className="prayogam">Hari:(hi) Om Thath(u).<br />
    Sri Govindha Govindhagovindha Asya sri bhagavadha:(ha) Maha purushasya Sri Vishno:(ho) ajgnaya pravarthamanasya adhya brahmana:(ha) dvidhiya parardhe sri swedhavaraha kalpe vaivasvadha manvanthare kaliyuge prathame padhe
  </div>

  <div className="svk">For people in India</div>
  <div className="prayogam"> Jambhu dweepe Bharadha varshe bharadhakhande

  </div>

  <div className="svk">
      For people outside India:
      You can replace the word ‘Vishnu’ in all places for which you dont know the names of dweepam, varsham and kandam Example: Vishnu dweepe, Vishnu Varshe, Vishu Khande.

  </div>
<hr />
  <div className="svk">Manthram continues for all</div>
  <div className="prayogam">Sakaapthe meroho dhakshine paarswe asmin varthamaanaanaam
   vyavaharike Prabhavaadhi shasti samvathsaraanaam madhye .....
    .....</div>
    <hr />
  <div className="sans">
    हरि: ओं तत् (सत्) श्रीगोविन्द गोविन्द गोविन्द। अस्य श्रीभगवत: महापुरुषस्य श्रीविष्णो: आज्ञया प्रवर्तमानस्य अद्यब्रह्मण: द्वितीयपराार्धे
    श्रीश्वेतवराहकल्पे वैवस्त्वत मन्वन्तरे कळियुगे प्रथमेपादे जम्बूद्वीपे भारतवर्षे भरतखण्डे शकाब्दे मेरो: दक्षिणेपार्श्वे
    अस्मिन् वर्तमानानां व्यवहारिकाणां प्रभवादीनां षष्टिसंवत्सराणां मध्ये
  </div>
  <div className="clear"></div>

<hr />
  <div className="head2">
   Sankalpam for 27-08-2026 :
  </div>
  <hr />

  <div className="prayogam">
  
   parabhava Naama Samvatsare<hr />
          dhakshinayane<hr />
          varsha ruthau<hr />
          simha mase<hr />
          sukla pakshe<hr />
          chaturdasi (till 09.47 am) / powrNamaasyaam subha thithau<hr />
          guru vaasara yukthayam<hr />
          sravishta (avittam) nakshatra yukthaayam<hr />
          sobhana yoga yukthaayam<hr />
          vanija karana yukthaayam<hr />
          yevanguna visehana visishtaayam powrNamaasyaam subha thithau

  </div>
<hr />
<div className="sans">
  विश्वावसु नाम संवत्सरे दक्षिणयने - ग्रीष्म ऋतौ   कटक मासे शुक्ल पक्षे 
पौर्णमास्यां (14.20 pm) शुभ तिथौ - वासर:
        स्थिर वासर युक्तायां -
        श्रवण (15.58 pm) / श्रविष्टा नक्षत्र युक्तायां - (till 06.10 am आयुष्मान्) सौभाग्य योग युक्तायां - व (14.20 pm) /बालव करण युक्तायां एवङ्गुण विशेषण विशिष्टायां अस्यां पौर्णमास्याम् शुभ
         तिथौ श्रीभगवदाज्ञया श्रीमन्नारायण प्रीत्यर्थं 
</div>

   <div className="mydiv">ஸ்ரீ-ம் (Hint:- Please keep this in mind to say as per your sampradayam wherever you find
   "Sri-m:"<br />
    <span style={{"backgroundColor": "yellow"}}> Vada Kalai :</span>
    Sri bhagavadhagnaya Sriman Narayana preethyartham,
    <br /> <span style={{"backgroundColor": "yellow"}}>Then Kalai : </span>
    Sri bhagavadhagnaya bhagavath kainkarya roopam,
    <br /> <span style={{"backgroundColor": "yellow"}}>ஸ்மார்த்தா</span>
     Mamo paatha samastha durithakshaya dwara , Sri Parameshwara preethyartham  </div>
     <div className="hint">Both kalai and Smarthaa to continue :</div>
    <div className="clear"></div>

<hr />
  <div className="head2">Yagnopaveetha dharana sankalpam: </div>
<hr />
  <div className="prayogam">Chrowdha smartha vidhi vihitha nithya karma anushtana yogyadha
  sidhyartham brahma thejaha abhiviruthiyartham yagnopaveetha dharanam karishye! </div>
<div className="sans">
    मम श्रौतस्मार्त वितिविहित न्त्यिकर्म अनुष्टान योग्यता सिध्यर्थं ब्रह्मतेज:
    अभिवृद्धयर्थं यज्ञोपवीत धारणं करिष्ये।
</div>
  <div className="hint"> (This is called sankalpam, after this leave the short
   dharbhams on your left side i.e in north) </div>
<hr />
  <div className="head2">Yagnopaveetha dharana nyaasam :</div>
<hr />
<div>
    <img src="assets/img/Nyaasam1.jpg" className="img2" />

    <div className="hint">Touch your fore head and tell :-</div>
    <div className="prayogam">'Yagnopaveetha dhaarana manthrasya brahmaa rushi:</div>
    <div className="sans">यज्ञोपवीत धारण मन्त्रस्य ब्रह्मा ऋषि:</div>
  </div>

  <div className="clear"></div><hr />

  <div>
    <img src="assets/img/Nyaasam2.jpg" className="img2" />

    <div className="hint">Touch your nose tip and tell :-</div>
    <div className="prayogam">'Anushtup chandha:(ha)'</div>
    <div className="sans">अनुष्टुप् छन्द:</div>

  </div>
  <div className="clear"></div><hr />



  <div>
    <img src="assets/img/Nyaasam3.jpg" className="img2" />
    <div className="hint">Touch your chest and tell :-</div>
    <div className="prayogam">'Thrayee vidhya devadha'</div>
    <div className="sans">त्रयीविद्या देवता</div>

  </div>
  <hr />

  <div>
    <img src="assets/img/Nyaasam4.jpg" className="img2" />

    <div className="hint">Roll both the palm towards your chest and tell :-
    </div>
    <div className="prayogam"> 'Yagnopaveetha dharane viniyoga:(ha)'</div>
    <div className="sans">यज्ञोपवीत धारणे विनियोग:</div>
  </div>
 <div className="head2">Yagnopaveetha dhaaranam : </div>
<hr />
<img src="assets/img/Poonal-BrahmaMudichu.jpg" />
<hr />
  <div>
      <img src="assets/img/poonal-position.jpg" className="img2" />

      <div className="hint">Hold the ‘poonal’ as shown in the picture and tell:- </div>
</div>
<div className="clear"></div>
<hr />
<div>
    <img src="assets/img/insert-poonal.jpg" className="img2" />

  <div className="prayogam">‘Yagnopaveetham - paramam - pavithram -
  prajapathe:(he) - yathsahajam - purasthath - aayushyam - agryam - prathimunjasubram -
  yagnopaveetham - bhalamasthu - theja:(ha).' </div>
</div>
<div className="clear"></div>
<div className="sans">
    यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
    अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
</div>

  <div className="hint">insert right and take out left hand to place on left shoulder
  and to hang under right hand.</div>
  <hr />
  <div>
      <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
      <div className="hint">Now brahmacharies should wait for a while when grahasthas are wearing the second poonal.<br />
Grahasthas remove and put the pavithram in the right ear and do one achamanam, then wear pavitram and do one praanayamam.</div>
    </div>
    <div className="clear"></div>
<hr />
<div>
<img src="assets/img/praanaayaamam.gif" />
</div>

<hr />
  <div><img src="assets/img/Sankalpam.jpg" className="img2" />
  <div className="prayogam">Sri bhagavadhagnaya ..... m grahastha aasramaartham dvitheeya yagnopaveetha dhaaranam karishye! </div>
     <div className="sans">
        ग्रहस्त आश्रमार्थं िद्वतीय यज्ञोपवीत धारणं करिष्ये।
     </div>
     </div>
<hr />
<div>
    <img src="assets/img/Nyaasam1.jpg" className="img2" />

    <div className="hint">Touch your fore head and tell :-</div>
    <div className="prayogam">'Yagnopaveetha dhaarana manthrasya brahmaa rushi:</div>
    <div className="sans">यज्ञोपवीत धारण मन्त्रस्य ब्रह्मा ऋषि:</div>
  </div>

  <div className="clear"></div><hr />

  <div>
    <img src="assets/img/Nyaasam2.jpg" className="img2" />

    <div className="hint">Touch your nose tip and tell :-</div>
    <div className="prayogam">'Anushtup chandha:(ha)'</div>
    <div className="sans">अनुष्टुप् छन्द:</div>

  </div>
  <div className="clear"></div><hr />



  <div>
    <img src="assets/img/Nyaasam3.jpg" className="img2" />
    <div className="hint">Touch your chest and tell :-</div>
    <div className="prayogam">'Thrayee vidhya devadha'</div>
    <div className="sans">त्रयीविद्या देवता</div>

  </div>
  <hr />

  <div>
    <img src="assets/img/Nyaasam4.jpg" className="img2" />

    <div className="hint">Roll both the palm towards your chest and tell :-
    </div>
    <div className="prayogam"> 'Yagnopaveetha dharane viniyoga:(ha)'</div>
    <div className="sans">यज्ञोपवीत धारणे विनियोग:</div>
  </div>
 <div className="head2">Yagnopaveetha dhaaranam : </div>
<hr />
<img src="assets/img/Poonal-BrahmaMudichu.jpg" />
<hr />
  <div>
      <img src="assets/img/poonal-position.jpg" className="img2" />

      <div className="hint">Hold the ‘poonal’ as shown in the picture and tell:- </div>
</div>
<div className="clear"></div>
<hr />
<div>
    <img src="assets/img/insert-poonal.jpg" className="img2" />

  <div className="prayogam">‘Yagnopaveetham - paramam - pavithram -
  prajapathe:(he) - yathsahajam - purasthath - aayushyam - agryam - prathimunjasubram -
  yagnopaveetham - bhalamasthu - theja:(ha).' </div>
</div>
<div className="clear"></div>
<div className="sans">
    यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
    अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
</div>

  <div className="hint">insert right and take out left hand to place on left shoulder
  and to hang under right hand.</div>
  <hr />



  <div className="hint">Now brahmacharies & grahasthas remove the old poonal by saying :
</div>
  <div className="prayogam">“Upaveetham - bhinnadhanthum - jeernam - kasmaladhooshitham - visrujami -
jalebrahmannu - varcha:(ha) - dheerghayu:(hu) - ashthume!” </div>
    <div className="sans">
        उपवीतं भिन्नतन्तुं जीर्णं कश्मलदूषितम्।<br />
        विसृजामि जले ब्रह्मन् वर्च: दीर्घायु: अस्तु मे।।
    </div>
<hr />
<div>
    <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
  <div className="hint"> After removing the old poonal, put the pavithram in the right ear
  do one achamanam </div>
    </div>
    <img src="assets/img/new-achamanam.gif" />
    <div className="mydiv">
    <div className="svk">Next 'kamokarsheet japam' is not to be done
    by the brahmachari doing 'Thalai (first) Avani avittam'</div>
</div>
<div className="clear"></div>
<br />
<hr />
  <div className="head2">Kamokaarsheeth Japam</div>
<hr />

  <div className="hint">Now go through the sankalpam for Kamokaarsheeth japam:-
  Wear the pavithram (if it is still in the ear)</div>
    <hr />

     <div>
      <img src="assets/img/Sankalpam.jpg" className="img2" />
      <div className="hint">keep the open left hand on right thigh
      and  close it by right hand </div>
      </div>

  <div className="prayogam"> “ Sri-m| “thaishyam - powrnamasyam - adhyaya - uthsarjana - akarana - prayachiththartham
    </div><div className="hint" style={{"float": "left"}}>For 108 :</div>
    <div className="prayogam">Ashtothra satha</div>
   <div className="hint" style={{"float": "left"}}>For 1008: </div>
   <div className="prayogam">Ashtothra Sahasra
    - sankhyaya - ‘Kamokaarsheeth - manyura kaarsheeth’ - ithi - manthra - japam - karishye! </div>
    <div className="clear"></div>
    <div className="sans">
        तैष्यां पौर्णमास्यां अद्धयाय उत्सर्जन अकरण प्रायश्चित्तार्थं अष्टोत्तर शत(108) / सहस्र(1008)
        सङ्ख्या कामोकार्षीत् मन्युरकार्षीत् इति महामन्त्र जपं करिष्ये।
    </div>
    <div className="hint"> After this sankalpam </div>
     <div className="mydiv">vada kalai only to tell as: "kamokaarsheet japaakyam karma swasmai swapreethaye
     bhagavan swayameva kaarayati" </div>
    <div className="hint">All should do 'kamokaarsheet jpam 108 or 1008
    counts as per your sankalpam </div>
    <hr />
    <div className="prayogam">"kamokaarsheet manyurakaarsheet" </div>
    <div className="sans">कामोकार्षीत् मन्युरकार्षीत्</div>
    <hr />
    <div className="hint">After completion of this japam<br />
    stood up and say </div>
    <div className="prayogam">"kamokaarsheet manyurakaarsheet namo namaha:“ </div>
    <div className="sans">कामोकार्षीत् मन्युरकार्षीत् नमो नम:|</div>

    <div className="hint">do namaskaram 1 or 3 or 4 times as your sampradayam<br />
    and do abhivadhi </div>

    <div className="mydiv">vadkalai only to say "bhagavaneva Swasesha
    bhootamitam kamokaarsheet japaakyam karma swasmai swapreethaye bhagavan
    swayameva kaaritavaan (sativka thyagam) </div>

    <div className="hint">If you have one more pavitram for
    kandarushi tarpanam, now you can untie it,
    otherwise keep it safe and do one achamanam </div>

    <div className="mydiv">
      <div className="svk">
      brahmacharis should undergo for kshavaram
      <br /> All should take bath once as per shastra
      (but elders and patients can skip)<br />
      wear silk dhoti or madi one, thiruman
      kaapu etc. do madhyahnigam and get ready.</div>
   <div className="svk">If possible and willing 'snana maha sankalpam
   can also can take (by getting in from other menu in this app)<br />
   Normally Kandarushi tarpanam will be done collectively at a
   common place like river or pond. Which is the highlight of this karma,
   but now a days people are thinking doing it in their own house is good
   which is wrong.
     </div>
</div>
<div className="clear"></div>

<hr />
<div className="head2">Kandarushi Tarpanam</div>
<hr />
<div className="hint">Wear pavitram and do praanaayaamam.</div>
<hr />
<div>
    <img src="assets/img/praanaayaamam.gif" />
  </div>
    <div className="prayogam">Om bhoohu Om bhuvaha O(gu)m suvaha Om mahaha Om janaha Om thapaha Om sathyam tatsavidhurvareaNyam bhargodhevasya dheemahi
      dhiyoyonah prachodhayaadh Omaapaha jyotheerasaha amrutham brahma bhoor bhuva suvar Om</div>

    <div className="hint">(Do Perumal Aradhanam but Dheertham should
    be taken after completion of Upakarma) The second snanam after sankalpam and
    Yajgnopaveeta dhAranam as part of ‘kANda rushi tarpaNam’ also specified as per
    “Kandapooshanam”. Also the sankalpam for kaandarushi tharpanam in that book is
    very very simple. i.e:- “Sravanyam Powrnamasyam Adhyaya
    Upakarma Karishye”. But some vadhyars are giving a long sankalpam as here under.</div>
 <div>
        <img src="assets/img/Sankalpam.jpg" className="img2" />
        <div className="hint">keep the open left hand on right thigh
      and  close it by right hand</div>
      </div>
      <div className="clear"></div>
      <div className="prayogam">“Sri bhagavadhagnaya - sriman narayana preethyartham -
       or bhagavath kainkaryam - Sri ranga kshethre -
       Sriranga nayika samedha Sriranganatha swami sannidhow -
        Sri Alarmel manga nayika sametha Sri Srinivasa swami sannidhow
        - Sri Perundevi nayika samedha Sri Devadhiraja swami sannidhow -
         Shravanyam - powrnamasyam - adhyaya - upakarma - karishye. Thathangam
          - Kaveri snanamaham - karishye. Thathangam - Yagnopaveetha - dharanam - karishye. Thathangam Kaandarushi tharpanam karishye.”
<br /><br />
Brahmacharies may say ‘Thathangam - mounji - ajina - dhanda - dharananicha - karishye.”
<br /><br />
Brahmacharies wear Mounji, Ajinam, Dhandam with manthram:. <span style={{"backgroundColor": "yellow"}}> (ப்ரஹ்மசாரிகள் மட்டும்) ததங்கம் மௌஞ்சி
    அஜின தண்ட தாரணாநிச கரிஷ்யே.</span></div>
    <div className="sans"> </div><hr />
<div className="mydiv">
    <div className="hint">vada kalai only: bhagavaneva swasesha bhootamitam adhyaaya upakarmakyam
    swasmai swapreethaye bhagavan swayameva kaarayati </div>
<hr />
    <div className="hint">Using the below given mantrams, brahmacharis should wear:
    Ajinam, dhandam and mounji belt.</div>
     </div>
     <br />
     <hr />
     <div className="head2">Mounji Mantram</div>
     <hr />
  <div>
      <img src="assets/img/Mounji.jpg" className="img1" />
      <div className="prayogam">Iyam dhurukthaadh paribaadhamaanaa sarma varootham punatheena:
      aagaath praanaapaanaabhyam bhalam aabharanthi priyaa dhevaanaam subhagaa maekhalaa
      iyam ruthasya gopthree thapasa: paraspee gnathee raksha: sahamaanaa araathi
      saanaha samantham anu pareehi bardhrayaa bardhaarasthae maekalae maarishaamaa
      - wear the mounji.</div>
      <div className="sans">
          इयं दुरुक्तात् परिबाधमाना शर्म वरूथं पुनतीन: आगात् ।<br />
           प्राणाभानाभ्यां बलं आभरन्ती प्रिया देवानां सुभगा मेखला इयम् । <br />
  ऋतस्य गोप्त्री तपस: परस्पी घ्नती रक्ष: सहमाना अराती:।<br />
   सान: समन्तं अनू परीहि भद्रया भर्तारस्ते मेखले मारिषाम ।।

      </div>
    </div>
    <div className="clear"></div>
    <div className="head2">Ajina dharana manthram:</div>
  <div>
      <img src="assets/img/Ajinam.jpg" className="img1" />
      <div className="prayogam">Mithrasya chakshu: dharunam baleeya:
       thaeja: yasasvee sthaviram samidhdham anaahanasyam
      vasanam jarishnu pareedham vaajee ajinam dhadhaeham</div>
      <div className="sans">
          मित्रस्य चक्षु: धरुणं बलीय: तेज: यशस्वि स्थविरं समिद्धं । <br />
          अनाहनस्यं वसनं जरिष्णु परीदं वाजि अजिनं दधेहम् ।
      </div>
</div>
<div className="clear"></div>
<div className="head2">Dhanda dharana manthram:</div>
  <div>
      <img src="assets/img/Dhandam.jpg" className="img1" />

      <div className="prayogam">susravasam maa kuru yadhaatvam susrava: susravaa:
       asi yaevamaham susrava: susravaa: bhooyaasam yadhaathvam susrava: dhevaanaam nidhigopa:
      asi yaevamaham braahmanaanaam brahmana: nidhigopa: bhooyaasam</div>
      <div className="sans">
          सुश्रव: सुश्रवसं माकुरु यथात्वं <br />
          सुश्रव: सुश्रवा: असि एवमहं <br />
          सुश्रव: सुश्रवा: भूयासं यथात्वं<br />
          सुश्रव: देवानां निधिगोप: असि एवमहं<br />
          ब्राह्मणानां ब्रह्मण: निधिगोप: भूयासम् ।।
      </div>
</div>
<div className="clear"></div>
<div className="svk">The before said snanam has to be done after this sankalpam
and then again wearing the veshti, thiruman etc, and then the kandarushi
tarpanam has to be done.<br />
     <hr />
     To do tharpanam choose a right place to pour plenty of water. Make ready with ‘Akshathai’, ‘Ell’ and plenty of water.</div>
    <hr />

    <div className="head2">காண்ட ருஷி தர்பணம்</div>
    <hr />

    <div className="hint">Do tharpanam as described here. Please understand
    the postures or mudhra for the corresponding tharpanam.<br />
There are only four postures to do tharpanams, understand and do correctly
as described : (see picture)</div>
     <hr />

    <div>
        <img src="assets/img/DevaTheertham1.jpg" className="img1" />


        <div className="hint"><span style={{"backgroundColor": "yellow"}}>
        1.Deva Theertham :</span>let the water to flow & drop through the finger tips</div>
</div>
<div className="clear"></div>
<hr />

  <div>
      <img src="assets/img/PithruTheertham2.jpg" className="img1" />

      <div className="hint"><span style={{"backgroundColor": "yellow"}}>
      2. Pithru Theertham :</span> let the water flow through the
      gab between theright thumb and index finger.</div>
</div>
<div className="clear"></div>
<hr />
  <div>
      <img src="assets/img/BrahmaTheertham1.jpg" className="img1" />

  <div className="hint"><span style={{"backgroundColor": "yellow"}}>
  3. Brahma Theertham  :</span> shift up  both the hands to allow
  the water to drain down towards the wrist and then elbow.</div>

</div>
<div className="clear"></div>
<hr />
<div>
    <img src="assets/img/RushiTheertham1.jpg" className="img1" />
  <div className="hint"><span style={{"backgroundColor": "yellow"}}>
  4. Rushi Theertham : </span>
  let the water to flow under the little fingers of both the hands
  by making a small hole in the middle.</div>
  </div>
  <div className="clear"></div>
<hr />

  <div className="hint">Note:- Each tharpanam should be done thrice.
    </div>
    <br />
    <hr />
    <div>
      <img src="assets/img/RushiTheertham1.jpg" className="img1" />
     <span style={{"backgroundColor": "yellow"}}>Rushi Tharpanam
 (Bring the Poonal to ‘niveethi’ position as a garland & take akshathai)</span></div>
<div className="clear"></div>
<hr />
  <div className="prayogam">
    1. Prajapathim Kandarushim tharpayami <br />
2. Somam Kandarushim tharpayami<br />
3. Agnim Kandarushim tharpayami<br />
4. Viswandevan Kandarusheen tharpayami
  </div>
  <div className="sans">
      प्रजापतिं काण्डऋषिम् तर्पयामि ।<br />
      सोमं काण्डऋषिम् तर्पयामि ।<br />
      अग्निं काण्डऋषिम् तर्पयामि ।<br />
      विस्वान् देवान् काण्डऋषिम् तर्पयामि ।
  </div>
  <hr />
  <div>
      <img src="assets/img/DevaTheertham1.jpg" className="img1" />
  <div className="hint">Deva tarpanam, bring poonal to usual /
  upaveedi stage.
  </div>
</div>
  <div className="prayogam">
    5. Sahumhideepya:(ha) Devadha:(ha) Upanishadha:(ha) tharpayami<br />
6. Yangigheepya:(ha) Devadha:(ha) Upanishadha:(ha) tharpayami<br />
7. Vaaruneepya:(ha) Devadha:(ha) Upanishadha:(ha) tharpayami</div>
    <div className="sans">
        साँहितीर्देवता: उपनिषत: तर्पयामि ।<br />
        याज्ञिकी: देवता: उपनिषत: तर्पयामि ।<br />
        वारुणी: देवता: उपनिषत: तर्पयामि ।
      </div>
      <hr />
  <div>
      <img src="assets/img/BrahmaTheertham1.jpg" className="img1" />
      <div className="hint">
  keep the poonal as usual /
  upaveedi stage. </div>
</div>
<div className="clear"></div>
  <div className="prayogam"> 8. Brahmanam swayambhuvam tharpayami</div>
  <div>
      <div className="sans">
          ब्रह्माणम् स्वयम्भुवम् तर्पयामि ।
        </div>
        <hr />
      <img src="assets/img/DevaTheertham1.jpg" className="img1" />
  <div className="hint"> Deva Tarpanam keep the poonal as usual /
  upaveedi stage.
  </div>
</div>
<div className="clear"></div>


  <div className="prayogam">
  9. Sadhasaspathim tharpayami<br />
10. Rig vedham tharpayami<br />
11. Yajur vedham tharpayami<br />
12. Sama vedham tharpayami<br />
13. Atharva vedham tharpayami<br />
14. Idhikasam tharpayami<br />
15. Puranam tharpayami<br />
16. Kalpam tharpayami</div>
    <div className="sans">
        सदसस्पतिं तर्पयामि ।<br />
        ऋग्वेदं तर्पयामि ।<br />
        यजुर्वदं तर्पयामि ।<br />
        सामवेदं तर्पयामि ।<br />
        अधर्ववेदं तर्पयामि ।<br />
        इतिहासं तर्पयामि ।<br />
        पुराणं तर्पयामि ।<br />
        कल्पं तर्पयामि ।
      </div>
      <hr />
  <div>
          <img src="assets/img/PithruTheertham2.jpg" className="img1" />
  <div className="hint"><span style={{"backgroundColor": "yellow"}}> Pithru Tharpanam :</span>
  Below pithru tarpanam is only
  for people whose father is not alive.
(Bring the Poonal to ‘Pracheena veethi’ -
 opposite to usual and use ‘Ell’ with akshathai)
 Each tharpanam should be done thrice.</div>
</div>
  <div className="prayogam">
17. Soma pithruman - yama:(ha) - angeeraswan - agni:(hi) -
Kavyavahanadhya:(ha) - Yepithara:(ha) thaan pithrun tharpayami.<br />
18. Sarvan pithrun - tharpayami<br />
19. Sarva pithru gana:(ha) tharpayami<br />
20. Sarva pithru pathni:(hi)- tharpayami<br />
21. Sarva pithru gana pathni:(hi) tharpayami<br />
22. Oorjam vahanthee:(hi) - Amrutham - grutham paya:(ha)
 - keelalam - parisrutham - swathastha - tharpayathame - rushi - pithruun.
Thrupyatha - thrupyatha - thrupyatha.</div>
    <div className="sans">
        (प्राची)- सोम:पितृमान् यम: अङिगरस्वान् <br />
        अग्नि: कव्यवाह: इत्यादय: येपितर: <br />
        तान् पितृृन् तर्पयामि ।<br />
        सर्वान् पितृन् तर्पयामि ।<br />
        सर्वपितृगणा: तर्पयामि ।<br />
        सर्वपितृपत्नी: तर्पयामि।<br />
        सर्वपितृ गणपत्नी: तर्पयामि ।<br />
        उूर्जंवहन्ती: अमृतं घृतं  पय: <br />
        कीलालं परिसृतं स्वधास्थ <br />
        तर्पयतमे पितृन् ।<br />
        तृप्यत । तृप्यत । तृप्यत ।।<br />
        उपवीति।
      </div>
<hr />
<div>
    <img src="assets/img/pavithram-in-ear.jpg" className="img2" />
  <div className="hint">Kaandarushi tharpanam over! Next Vedha Aarambham.
   If you are doing it in your house, keep the pavithram in
   your right ear and do achamanam. If you are doing it in
   the bank of a river or a lake remove
  and untie  the pavithram and do achamanam twice.</div>
    </div>
    <div className="clear"></div>
    <hr />
    <div>
        <img src="assets/img/new-achamanam.gif" />
      </div>
      <hr />
  <div className="head2">Vedha - Aarambham</div>
  <div>
      <img src="assets/img/Sankalpam.jpg" className="img2" />     
  <div className="prayogam">"Vedhaarambam karishye"</div>
  <div className="sans">वेदारम्भं करिष्ये ।
    </div>
  <div className="hint">after this sankalpam,
  chant the below veda mantras with its swaram
  if you know well.</div>
</div>
<div className="clear"></div>

  <div className="prayogam">
  “Hari: Om - Agnimeele purohitham - yagnasya - dhevamruvijammm-
   hothaaaram - rathnadhathamam - hari: Om”<br />
“Hari: Om - Yishethvaaa - oorjethvaaa- vayavastha -
upayavastha - dhevovaha - prarpayathu - sreshtathamaya -
karmane - hari: Om”<br />
“Hari: Om - Agnaaayhi - veedhayeaaa- grunana:(ha) -
havyadhathayeaa - nihotha - sathsi bharhishi - hari: Om”<br />
“Hari: Om - Sannodhevi: - abhishtayeaa - aapobhavanthu -
 peethayeaaa - saymyo:(ho) - abhisravanthuna: (ha) - hari: Om”<br />

  </div>
  <div className="sans">
      हरि: ॐ। अग्निमीळे पुरोहितं - यज्ञस्य - देवमृत्विजम् ।
      होतारं - रत्नधातमं । हरि: ॐ।<br /><hr />
      हरि: ॐ। इषेत्वा - उूर्जेत्वा - वायवस्थ - उपायवस्थ - देवोव: - सविता -
      प्रार्पयत् श्रेष्टतमाय - कर्मणे । हरि: ॐ।<br /><hr />
      हरि: ॐ। अग्न आयाहि - वीतये - गृणान: - हव्यदातये ।
      निहोता - सत्सि - बर्हिषि । हरि: ॐ।<br /><hr />

      हरि: ॐ। शन्नोदेवेरभिष्टये - आपोभवन्तु - पीतये - शँयोरभिस्रवन्तुन: । हरि: ॐ।
    </div>
 
<hr />
  <div className="mydiv">Vadakalai only should say :-
  <div className="prayogam">
  “Bhagavaneva swasesha
  bhoothamidham upakarmakyam karma swasmai
  swapreethaye bhagavan swayameva kaarithavaan”</div>
  <div className="hint">If anybody still wearing the pavithram,
  remove and untie it and throw it.
   All should do achamanam twice.</div>
  </div>
<hr />

          <img src="assets/img/shastanga-namaskaram.JPG" className="img1" />

        <div className="hint">
          get up and do namaskaram as per sampradayam
           </div>
           <div className="clear"></div><hr />
        <img src="assets/img/abhivathi.jpg" className="img1" />

        <div className="hint">
          do abhivadhi.</div>
          <div className="clear"></div><hr />
 <hr />
<div>
  <img src="assets/img/kaikoopu.jpg" className="img2" />
  <div className="hint">Keep hands as doing namaskaram and  tell</div>
</div>
<div className="clear"></div><hr />
    <hr />
    <div className="svk">
      all can recite
    </div>
<div className="prayogam">
  ”
 “Kaayena vaacha - manase -
 indhriyarvaa - bhudhya - athmanaava - prahrudhe:(he) - swabhavaadh -
  karomi - yathyadh - sakalam - parasmai - sriman naarayanayethi - samarpayami”
“Sarvam Sri Krishnarpanam asthu. Achydha preeyatham”.
</div>
<div className="sans">
  कायेन वाचा मनसेन्द्रियैर्वा ।
  <br /> बुद्ध्यात्मना वा प्रकृतिस्वभावात् ।
  <br /> करोमि यद्यत्सकलं परस्मै ।
  <br /> नारायणयेति समर्पयामि ॥
</div>
<hr />
<div className="hint">
If you did the upakarma
in a common place and returnin to house, ask the ladies to take harathi.

    <hr />
    This is the end of Upakarma.
    </div>
<hr />
<div className="svk">First you go to the perumal (pooja) room and do namaskaram to permal
and then do namaskaram to periyavals (elders).
 If possible call relatives and friends to your house and
 take food with them. Enjoy this day.</div>
  <div className="item"> I pray Emperuman to bless all your family
  with good health and longivity with all desirable good things
  throughout your life. Be happy with parents, relatives and friends.
  Blessings or Wishses.
  <br />
 Dasan<br />
  Vadhyar - Dr.NVS </div>
<hr />
</div>

</div>
</div>

  );
}
